module.exports = require('./abstract-annual-report').extend({
    model: function() {
        return this.modelFor('annual_report')
    },

    setupController: function(controller, model) {
        controller.set('model', model)
        controller.set('steps', model.steps)
        controller.set('years', model.years)
        controller.set('currentStep', model.currentStep)
    }
})
